import { render, staticRenderFns } from "./DefaultPlanCreate.vue?vue&type=template&id=5de3a2a4&"
import script from "./DefaultPlanCreate.vue?vue&type=script&lang=js&"
export * from "./DefaultPlanCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports